module.exports = __webpack_public_path__ + "img/circle-line.dc2f0ee8.svg";